module.exports = __webpack_public_path__ + "static/conference-73edc5c1e73863cff5f10bf834c1b483.jpg";